import { SseEvent } from './sse-event.interface';
import { SseEventType } from './sse-event-type.model';
import { inject, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AppData } from '../../services/AppData';
import { GlobalMessageClientService } from '../../services/client/global-message-client-service/global-message-client.service';
import { CompoApp } from '../../services/CompoApp';
import { Store } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';

export abstract class SseEventBase implements SseEvent {

  abstract type: SseEventType;
  abstract onMessage: (event: MessageEvent<any>) => void;

  protected injector = inject(Injector);
  protected ngZone = inject(NgZone);
  protected router = inject(Router);
  protected store = inject(Store);
  protected translateService = inject(TranslateService);

  protected data = inject(AppData);
  protected messageClientService = inject(GlobalMessageClientService);
  protected on = inject(CompoApp).on;
  protected inProgressMessageService = inject(CompoApp).inProgressMessageService;

  public addListener(eventSource: EventSource): void {
    eventSource.addEventListener(this.type, this.onMessage);
  }

  protected hasEvents(resp: any): boolean {
    return resp.events?.length > 0;
  }
}
